import { render } from "./Patients.vue?vue&type=template&id=fd5035f8&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"

import "./Patients.vue?vue&type=style&index=0&id=fd5035f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fd5035f8"

export default script